export default __webpack_public_path__ + "static/media/block-distribute-vertically.e52fce85.svg";